import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import usePageProps from '@/routes/usePageProps';
import StoreGroupPage from '@/pages/StoreGroupPage';

const StoreGroup: React.FC<RouteComponentProps> = props => {
  const pageProps = usePageProps({ props });

  if (pageProps.reducersState.app.loadingPlatformConfig) {
    return null;
  }

  return <StoreGroupPage {...pageProps} />
};

export default StoreGroup;
